import request from '@/utils/request'
// import qs from "qs";

/*
  系统管理-用户管理 权限操作api
*/


// 查询用户列表
export function getUserList(data) {
  return request({
    url: 'user-service/user/getUserList',
    method: 'get',
    params: data
  })
}

// 根据userName查询用户信息
export function getUserByUserName(data) {
  return request({
    url: 'user-service/user/getUserByUserName',
    method: 'get',
    params: data
  })
}

// 新增
export function addSubmitApi(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'user-service/user/saveSysuser',
    method: 'post',
    data
  })
}

// 修改
export function editSubmitApi(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'user-service/user/updateSysuser',
    method: 'post',
    data
  })
}

// 删除
export function delSubmitUserApi(data) {
  const delData = {
    userIds: data
  }
  return request({
    url: 'user-service/user/removeSysuser',
    method: 'get',
    params: delData
  })
}


// 获取用户操作记录
export function getOperationRecord(params) {

  return request({
    url: 'user-service/log/getLogList',
    method: 'get',
    params
  })
}


